export default __webpack_public_path__ + "static/media/15@3x.15cfe751.png";